import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Card from '~c/components/base/card';

interface Props extends React.PropsWithChildren {
  className?: string;
  title?: React.ReactNode;
}

const SmallFormImpl: React.FC<Props> = ({ className, title, children }) => {
  return (
    <div className={className}>
      <Card
        className="container"
        title={title}
        variant="elevation"
        elevation={10}
      >
        {children}
      </Card>
    </div>
  );
};

/**
 * Render authentication related short forms that are centered
 * on the screen
 */
export const SmallForm = muiStyled(SmallFormImpl)(
  ({ theme }) => css`
    min-height: 100dvh;
    background: ${theme.palette.background.default};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing(3)} ${theme.spacing(2)};
    box-sizing: border-box;

    .container {
      width: min(calc(100% - 32px), 450px);
      position: relative;
    }

    @media (max-width: ${theme.breakpoints.values.sm}px) {
      align-items: flex-start;
      padding-top: ${theme.spacing(4)};

      .container {
        width: 100%;
      }
    }
  `
);

export default SmallForm;
